import TvTable from './TvTable';

export default TvTable;
